import React from 'react';
import TabbedPage from '../../../../Elements/TabbedPage';
import AssignmentsSubTab from './AssignmentsSubTab';
import LineItemsSubTab from './LineItemsSubTab';
import EvaluatorPaymentsSubTab from './EvaluatorPaymentsSubTab';

export default class ClientInvoiceDetailsDetailsTab extends React.Component {
  static defaultProps = {
    clientInvoiceId: 0
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  tabs = [
    {
      label: 'Assignments',
      id: 'assignments',
      icon: 'fa-solid fa-clipboard-list',
      component: <AssignmentsSubTab clientInvoiceId={this.props.clientInvoiceId} />,
      key: 'invoice_assignments'
    },
    {
      label: 'Line Items',
      id: 'lineitems',
      icon: 'fa-solid fa-paperclip',
      component: <LineItemsSubTab clientInvoiceId={this.props.clientInvoiceId} type='lineitem' />,
      key: 'invoice_lineitems'
    },
    {
      label: 'All',
      id: 'all',
      icon: 'fa-solid fa-book',
      component: <LineItemsSubTab clientInvoiceId={this.props.clientInvoiceId} type='all' />,
      key: 'invoice_all'
    },
    {
      label: 'Unpaid Items',
      id: 'unpaiditems',
      icon: 'fa-solid fa-xmark',
      component: <LineItemsSubTab clientInvoiceId={this.props.clientInvoiceId} type='unpaid' />,
      key: 'invoice_unpaid'
    },
    {
      label: 'Evaluator Payments',
      id: 'evaluatorpayments',
      icon: 'fa-solid fa-money-bill-wave',
      component: <EvaluatorPaymentsSubTab clientInvoiceId={this.props.clientInvoiceId} />,
      key: 'invoice_evaluatorpayments'
    }
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
